import React from 'react'
import parse from 'html-react-parser'
import feather from 'feather-icons'

import classNames from 'classnames'

// import styles from './style.module.scss'

// feather-icons 에 없는 커스텀 아이콘(피처 스타일 stroke, 24x24 viewBox). feather.icons 를
// 직접 오염시키지 않으므로 관리자 아이콘 피커(SelectFeatherIcon — Object.keys(feather.icons)
// 순회)에는 노출되지 않고, 픽스처/코드가 name 으로 명시적으로 참조할 때만 렌더된다.
// shield-check: 인증 코드(Authenticator) 전역 템플릿 아이콘 — feather 'shield'(빈 방패)에
// 안쪽 체크를 더한 형태(체크가 보여야 한다는 요구 반영).
const CUSTOM_ICON_CONTENTS = {
  'shield-check':
    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>' +
    '<path d="M8.5 11.5l2.5 2.5 4.5-4.5"></path>',
}

// feather.icons[name].toSvg 와 동일한 형태(기본 attrs + 전달 attrs + fe 클래스)로 커스텀
// 아이콘 SVG 문자열을 만들어 렌더한다. name 이 커스텀 목록에도 없으면 null(크래시 방지 —
// 렌더 중 throw 는 전역 에러 경계에서 빈 화면이 되므로 조용히 미표시).
function renderCustomIcon(name, rest) {
  const contents = CUSTOM_ICON_CONTENTS[name]
  if (contents == null) return null

  const attrs = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': 2,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    ...rest,
    class: classNames('fe', `fe-${name}`, rest.class),
  }
  const attrStr = Object.keys(attrs)
    .map((key) => `${key}="${attrs[key]}"`)
    .join(' ')
  const svg = `<svg ${attrStr}>${contents}</svg>`

  return <React.Fragment>{parse(svg)}</React.Fragment>
}

function FeatherIcon(props) {
  const { name, ...rest } = props

  // 보안(인증 코드) 템플릿 아이콘 'shield'(feather 의 빈 방패)는 항상 체크 든 방패로 표시한다
  // (사용자 요구 — 보안코드 템플릿을 쓰는 레코드/템플릿이면 무조건 체크 방패). icon 문자열은
  // 백엔드 template.icon 에서만 내려오고 코드에 하드코딩된 'shield' 사용처는 없어 전역 매핑이
  // 안전하며, 배포로 백엔드가 'shield-check' 를 주면 그대로 통과한다(멱등).
  const resolvedName = name === 'shield' ? 'shield-check' : name

  // feather-icons 미포함 이름은 커스텀 아이콘으로 폴백(shield-check 등)
  if (feather.icons[resolvedName] == null) {
    return renderCustomIcon(resolvedName, rest)
  }

  const attrs = {
    ...rest,
    class: classNames('fe', rest.class),
  }

  const svg = feather.icons[resolvedName].toSvg(attrs)
  const icon = parse(svg)

  return <React.Fragment>{icon}</React.Fragment>
}

export default FeatherIcon
